import { ENDPOINTS } from "./ENDPOINT"

/**
 * DashboardService.js
 * Handles all dashboard-related APIs
 */
const BASE = `${ENDPOINTS.cleanBase}/api/v1`
//const BASE = 'http://31.97.206.32:9005/api/v1'
// const BASE = 'http://31.97.206.32:9005/api/v1'

// ─── generic request helper (same pattern as BillService) ───
async function request(method, path, body) {
  const token = localStorage.getItem('token')

  const opts = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    cache: 'no-store',
  }

  if (body !== undefined) {
    opts.body = JSON.stringify(body)
  }

  const res = await fetch(`${BASE}${path}`, opts)

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`)
  }

  const text = await res.text()
  const json = text ? JSON.parse(text) : {}

  if (json.status === false) {
    throw new Error(json.message || 'API error')
  }

  return json.data
}

// shorthand helpers
const get = (path) => request('GET', path)

const appendDashboardFilters = (path, filters = {}) => {
  const params = new URLSearchParams()

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.set(key, String(value))
    }
  })

  const query = params.toString()
  return query ? `${path}?${query}` : path
}

// ─────────────────────────────────────────

const DashboardService = {
  // 🔹 1. Summary Cards
  getSummary: (filters = {}) =>
    get(appendDashboardFilters('/dashboard/summary', filters)),

  // 🔹 2. Table Status
  getTableStatus: () => get('/dashboard/table-status'),

  // 🔹 3. Recent Bills
  getRecentBills: (limit = 10, filters = {}) =>
    get(
      appendDashboardFilters('/dashboard/recent-bills', {
        limit,
        ...filters,
      })
    ),

  // 🔹 4. Payment Summary
  getPaymentSummary: (filters = {}) =>
    get(appendDashboardFilters('/dashboard/payment-summary', filters)),

  // 🔹 5. Top Selling Items
  getTopItems: (limit = 5, filters = {}) =>
    get(
      appendDashboardFilters('/dashboard/top-items', {
        limit,
        ...filters,
      })
    ),

  // 🔹 6. Sales Trend
  getSalesTrend: (range = '7days') =>
    get(`/dashboard/sales-trend?range=${range}`),
}

export default DashboardService


